import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpacesBySlugsKey } from '../../utils/keys';
export const useSpacesBySlugs = (options) => {
    const { variables, fields = 'basic', useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const spacesBySlugsKey = getSpacesBySlugsKey({ variables, fields });
    return useQuery(spacesBySlugsKey, () => client === null || client === void 0 ? void 0 : client.spaces.listBySlugs(variables, fields), useQueryOptions);
};
//# sourceMappingURL=useSpacesBySlugs.js.map